import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, BarCodeCategory, InteractionType, KeyValues10, KeyValues15, LocalService, PageKey, Status, TriggeredEvent } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';
import { MessageComponent } from '../../popups/message/message.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sellers',
  templateUrl: './sellers.component.html',
  styleUrls: ['./sellers.component.scss']
})
export class SellersComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["seller"]; userId: string = ''; ctryCode: string = '';
  wrappers: KeyValues15[]; categoryCode: BarCodeCategory = BarCodeCategory.ExploreProducts;
  selectedBusinessId: string = ''; interactionType: InteractionType = InteractionType.Business; isShowOtpPopup: boolean = false;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private router: Router, private modalService: NgbModal, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Sellers);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.onLoad();
    });
  }

  onLoad() {
    this.sellerManagementService.getBusinesses().subscribe(result => {
      this.wrappers = result;
    });
  }

  onActiveInactiveStatus(strId: string) {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.IsConfirmationType = true;
    modalRef.componentInstance.message = this.localService.languageContent.seller.delete_confirmation;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.selectedBusinessId = strId;
        this.isShowOtpPopup = true;
      }
    });
  }

  onRoute(biz_id: string, index) {
    switch (index) {
      case 1: {
        this.router.navigate(['/seller' + this.localService.basicParamsString, biz_id == '' ? '0' : biz_id]);
      } break;
      case 2: {
        this.router.navigate(['/products' + this.localService.basicParamsString, biz_id]);
      } break;
      case 3: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, biz_id, '0']);
      } break;
      case 4: {
        this.router.navigate(['/billings' + this.localService.basicParamsString, biz_id]);
      } break;
      case 5: {
        this.router.navigate(['/product-categories' + this.localService.basicParamsString, biz_id]);
      } break;
      case 6: {
        this.router.navigate(['/biz-products' + this.localService.basicParamsString, biz_id]);
      } break;
      case 7: {
        this.localService.copyContent(environment.url.app + 'bv/' + this.ctryCode + '/' + biz_id);
      } break;
      case 8: {
        this.router.navigate(['/plan-purchase', this.ctryCode, this.userId, 2, biz_id, 2]);
      } break;
    }
  }

  onGenerateBarCode() {
  }

  onBusinessUpdated(hasBusiness: boolean) {
    this.onLoad();
  }

  onVerifiedOtp(e: any) {
    this.isShowOtpPopup = false;
    this.sellerManagementService.activeInactiveStatus(this.selectedBusinessId, ActiveInactiveFor.Business).subscribe(result => {
      if (result.status == Status.Success) {
        const updatedItem = this.wrappers.find(x => x.key == this.selectedBusinessId);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
        this.wrappers = this.wrappers.filter(x => x.v2 == "1");
      }
    });
  }
}
